import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Region } from "../models/region"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class RegionService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'region/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllRegions(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Region>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllRegions?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  getAllregionbyDivision(Division_Id?: string): Observable<Array<Region>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllregionbyDivision/' + (Division_Id ? Division_Id : '')  ).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  viewRegion(RegionID?: string): Observable<Array<Region>> {
    return this.httpService.get(this.apiEndpoint + 'viewRegion/' + (RegionID ? RegionID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveRegion(locations: Region): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveRegion/', locations).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  deleteRegion(RegionID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteRegion/' + (RegionID ? RegionID : '00000000-0000-0000-0000-000000000000'), RegionID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(RegionId?: string,Code?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?&RegionId=' + (RegionId ? RegionId : '00000000-0000-0000-0000-000000000000')+'&Code=' + (Code ? Code : '')).pipe(map((result: any) => {
        return result; 
    }));
  }

  checkEmail(Emailid?: string,RegionId?: string): Observable<any> { 
    return this.httpService.get(this.apiEndpoint + 'checkEmail?Emailid=' + (Emailid ? Emailid : '')+ '&RegionId=' + (RegionId ? RegionId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
